import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateMasterPayment = createAsyncThunk('updateMasterPayment', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'payment',
            data: {
                "id": String(data?.values?.id),
                "recurring_payment": Number(data?.values?.recurringPayment),
                // "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
